export default "__VITE_ASSET__Dqc6Ju90__"